import React from 'react';
import '@/App.css';
import '@/designSystem.css';
import HeroSection from '@/components/HeroSection';
import TicketSection from '@/components/TicketSection';
import HighlightsSection from '@/components/HighlightsSection';
import FooterSection from '@/components/FooterSection';

const ChristmasPartyPage = () => {
  return (
    <div className="shyft-event-page" data-testid="event-page">
      <HeroSection />
      <HighlightsSection />
      <TicketSection />
      <FooterSection />
    </div>
  );
};

function App() {
  return <ChristmasPartyPage />;
}

export default App;
